import { GroupProps } from "./Group.types";

export default function Group<P>({ Component, count, ...componentProps }: GroupProps<P>): JSX.Element {
    return (
        <>
            {[...Array(count)].map((_, index) => {
                // skipcq: JS-0437 - Ignorar advertencia sobre falta de retorno en arrow function
                // @ts-ignore ts does not understand react's key prop
                return <Component key={index.toString()} {...componentProps} />;
            })}
        </>
    );
}
